import moment from "moment";
import React from "react";
import TextInput from "../widgets/TextInput";

export default class StipendiTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stipendi: this.props.stipendi, 
        };
    }

    componentDidUpdate() {
        if (this.props.stipendi !== this.state.stipendi) {
            this.setState({ stipendi: this.props.stipendi });
        }
    }

    setStipendi(stipendio, anno, mese) {
        let stipendi = this.state.stipendi;
        
        var t = stipendio.replace(/\./g, '');
        if(/[^0-9,]+/.test(t)) {
            t = t.replace(/[^0-9]+/g, '');
        }
        var chunks = t.split(',');
        chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        t = chunks.join(',');
        
        stipendi[anno][mese].importo = t;
        this.props.onChange(stipendi);
        this.setState({ stipendi });
    }

    render() {

        return(
            <div style={{ width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
                <table>
                    <tr>
                        <th style={firstColumn}>Anno</th>
                        <th style={column}>Gennaio</th>
                        <th style={column}>Febbraio</th>
                        <th style={column}>Marzo</th>
                        <th style={column}>Aprile</th>
                        <th style={column}>Maggio</th>
                        <th style={column}>Giugno</th>
                        <th style={column}>Luglio</th>
                        <th style={column}>Agosto</th>
                        <th style={column}>Settembre</th>
                        <th style={column}>Ottobre</th>
                        <th style={column}>Novembre</th>
                        <th style={column}>Dicembre</th>
                    </tr>
                    <tbody>
                        {this.state.stipendi.map((s, ind) => {

                            return(
                                <tr key={ind}>
                                    {s.map((stipendio, i) => {
                                        // let isPassed = i === 0 ? true : moment(stipendio.data, 'DD/MM/yyyy').isBefore(moment());
                                        return(
                                            <td style={i === 0 ? firstColumn : column}>
                                                <input type={'text'} value={i === 0 ? stipendio : stipendio.importo} style={{ width: 150, height: 40, border: '0px', backgroundColor: i === 0 ? 'transparent' : '#FFFFFF80' }} onChange={(e) => this.setStipendi(e.target.value, ind, i)} />
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

const firstColumn = {
    minWidth: 50, 
    maxWidth: 50, 
    textAlign: 'left', 
    width: 50, 
    height: 40, 
}

const column = {
    minWidth: 150, 
    maxWidth: 150, 
    textAlign: 'left', 
    width: 150, 
    height: 40, 
}